App.namespace.wrap('shared.RwdHelper', function () {

  var MOBILE_BREAKPOINT = 767;
  var TABLET_BREAKPOINT = 991;

  return {
    isMobileWidth: function () {
      return window.innerWidth <= MOBILE_BREAKPOINT
    },
    isTabletWidth: function () {
      return window.innerWidth <= TABLET_BREAKPOINT
    }
  }
});
